import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAppTranslationMutationVariables = Types.Exact<{
  input: Types.UpdateAppTranslationInput;
}>;


export type UpdateAppTranslationMutation = { __typename?: 'Mutation', updateAppTranslation: { __typename?: 'AppTranslationEntry', id: string, name: string, url: string, app_type?: string | null, created_at: string, updated_at: string } };


export const UpdateAppTranslationDocument = gql`
    mutation updateAppTranslation($input: UpdateAppTranslationInput!) {
  updateAppTranslation(input: $input) {
    id
    name
    url
    app_type
    created_at
    updated_at
  }
}
    `;
export type UpdateAppTranslationMutationFn = Apollo.MutationFunction<UpdateAppTranslationMutation, UpdateAppTranslationMutationVariables>;

/**
 * __useUpdateAppTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateAppTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppTranslationMutation, { data, loading, error }] = useUpdateAppTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppTranslationMutation, UpdateAppTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppTranslationMutation, UpdateAppTranslationMutationVariables>(UpdateAppTranslationDocument, options);
      }
export type UpdateAppTranslationMutationHookResult = ReturnType<typeof useUpdateAppTranslationMutation>;
export type UpdateAppTranslationMutationResult = Apollo.MutationResult<UpdateAppTranslationMutation>;
export type UpdateAppTranslationMutationOptions = Apollo.BaseMutationOptions<UpdateAppTranslationMutation, UpdateAppTranslationMutationVariables>;